<style scoped>
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="value.panelOpened = !value.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 header">チャット設定</h2>      
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/settings-for-chat"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ms-4">
      <div v-show="value.panelOpened">
        <label>
          <input type="checkbox" v-model="value.enabled" v-on:change="onChangeEnabled">
          <span class="ms-1">チャットで参加予約する</span>
        </label>
        <div class="mt-1">
          配信URL <input size="50" v-model="value.url" v-on:change="onChangeEnabled">
        </div>
        <div class="mt-1">
          <button class="btn btn-sm btn-primary"
            v-bind:class="{ 'btn-secondary': ! canConnect }"
            v-on:click="onClickConnect()"
            >チャット取得開始</button>
          <button class="ms-2 btn btn-sm btn-secondary"
            v-bind:class="{ 'btn-danger': isConnected }"
            v-on:click="onClickDisconnect()"
            >チャット取得終了</button>
        </div>
        <div class="mt-2">
          コマンド設定
          <table class="ms-4">
            <tr>
              <td class="align-top">コマンド位置</td>
              <td>
                <label><input type="radio" value="head" v-model="value.commandPlace"><span>先頭</span></label>
                <label class="ms-2"><input type="radio" value="any" v-model="value.commandPlace"><span>任意</span></label>
              </td>
            </tr>
            <tr>
              <td>参加希望コマンド</td>
              <td>
                <input size="40" v-model="value.commandToReserve">
              </td>
            </tr>
            <tr>
              <td>参加取消コマンド</td>
              <td>
                <input size="40" v-model="value.commandToCancel">
              </td>
            </tr>
            <tr>
              <td class="align-top">ハンター名登録書式</td>
              <td>
                <label><input type="radio" value="space" v-model="value.hunterNameSeparator"><span>スペース</span></label>
                <label class="ms-2"><input type="radio" value="atmark" v-model="value.hunterNameSeparator"><span>アットマーク</span></label>
                <label class="ms-2"><input type="radio" value="bracket" v-model="value.hunterNameSeparator"><span>括弧(丸括弧以外)</span></label>
                <span class="ms-4">{{exampleForEntryHunterName}}</span>
              </td>
            </tr>
            <tr>
              <td>除外キーワード</td>
              <td>
                <input size="40" v-model="value.excludedKeyword" />
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2">
          コマンド設定確認
          <div class="ms-4">
            <table>
              <tr>
                <td>名前</td>
                <td>チャット内容</td>
              </tr>
              <tr>
                <td><input type="text" size="16" v-model="sampleAuthor" /></td>
                <td><input type="text" size="50" v-model="sampleMessage" /></td>
                <td>
                  <button class="btn btn-sm btn-primary" v-bind:class="{ 'btn-secondary': ! canTest }" v-on:click="onClickTest">テスト</button>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="mt-2">
          コマンド判定結果
          <div class="ms-4">
            <table>
              <tr>
                <td>{{match(sampleMessage, value.commandToReserve) ? '⭕' : '❌'}}</td>
                <td>参加希望</td>
              </tr>
              <tr>
                <td>{{match(sampleMessage, value.commandToCancel) ? '⭕' : '❌'}}</td>
                <td>参加取消</td>
              </tr>
              <tr>
                <td>{{matchHunterName(sampleMessage) ? '⭕' : '❌'}}</td>
                <td>ハンター名登録{{matchHunterName(sampleMessage) ? ': ' + getHunterName(sampleMessage) : ''}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import _ from 'lodash'
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import YouTube from '@/components/resource/YouTube'

const INTERVAL_MSEC = 20 * 1000

export default {
  components: {
    CollapseTransition,
  },
  props: {
    value: { type: Object, required: true, },
  },
  data() {
    return {
      opened: false,
      intervalId: 0,
      sampleAuthor: '',
      sampleMessage: '',
      live: null,
      timestamp: 0,
    }
  },
  computed: {
    canConnect() {
      return this.value.enabled
          && ! this.isConnected
          && this.isValidUrl
    },
    isValidUrl() {
      let trimmed = this.value.url.trim()
      return trimmed.match(/https:\/\/www.youtube.com\/channel\/.+/)
          || trimmed.match(/https:\/\/www.youtube.com\/watch\?v=/)
    },
    isConnected() {
      return this.intervalId != 0
    },
    exampleForEntryHunterName() {
      let commandToReserve = this.value.commandToReserve.trim()
      if (commandToReserve == '') return ''

      let commandFormat = commandToReserve.split(' ')[0]
      let hunterNameFormat = 
        this.value.hunterNameSeparator == 'space' ? ' ハンター名' :
        this.value.hunterNameSeparator == 'atmark' ? '@ハンター名' :
        '<ハンター名>'
      return `例: ${commandFormat}${hunterNameFormat}`
    },
    canTest() {
      return this.sampleAuthor.trim() != '' && this.sampleMessage.trim() != ''
    },
  },
  methods: {
    async onChangeEnabled() {
      if (this.isConnected) {
        this.disconnect()
      }
    },
    async onClickConnect() {
      if (! this.canConnect) return
      if (this.isConnected) return
      

      await this.connect()
    },
    async connect() {
      if (this.intervalId != 0) return

      let {data, error} = await YouTube.getLive(this.value.url)
      if (error) {
        this.$toasted.error('エラー: チャット取得を開始できませんでした', { duration: 10 * 1000 }) 
        return
      }

      this.$toasted.success('チャット取得を開始しました')

      this.live = data
      await this.onInterval()
      this.intervalId = setInterval(this.onInterval, INTERVAL_MSEC)
      return true
    },
    onClickDisconnect() {
      if (! this.isConnected) return
      this.disconnect()
      this.$toasted.error('チャット取得を停止しました')
    },
    disconnect() {
      if (this.intervalId == 0) return

      clearInterval(this.intervalId)
      this.intervalId = 0
      this.timestamp = 0
    },
    async onInterval() {
      let chat = await YouTube.getLiveChat(this.live, this.timestamp)
      if (! chat) {
        this.$toasted.error('チャット取得に失敗しました', {duration: 10 * 1000})
        return
      }

      this.live.continuation = chat.continuation
      this.timestamp = chat.timestamp

      this.emitIfRequired(chat.comments)
    },
    onClickTest() {
      if (! this.canTest) return
      
      this.emitIfRequired([
        {
          timestamp: Date.now(),
          author: this.sampleAuthor,
          message: this.sampleMessage
        }
      ])
    },
    emitIfRequired(comments) {
      let reserves = comments.filter(c => this.match(c.message, this.value.commandToReserve))
      if (0 < reserves.length) {
        this.$emit(
          'reserve-member',
          reserves.map(m => makeEntry(m.author, this.getHunterName(m.message))))
      }

      let cancels = comments.filter(c => this.match(c.message, this.value.commandToCancel))
      if (0 < cancels.length) {
        this.$emit(
          'cancel-member',
          cancels.map(m => makeEntry(m.author, this.getHunterName(m.message))))
      }

      let changes = comments.filter(c => this.matchHunterName(c.message))
      if (0 < changes.length) {
        this.$emit(
          'change-hunter-name',
          changes.map(m => makeEntry(m.author, this.getHunterName(m.message))))
      }
    },
    match(s, command) {
      if ((s || '').trim() == '') return false
      if ((command || '').trim() == '') return false

      let excluded = this.value.excludedKeyword.trim()
      if (excluded != '' && new RegExp(makePattern(excluded)).test(s)) return false

      let prefix = makePrefix(this.value.commandPlace)
      let infix = makePattern(command)
      return new RegExp(prefix + infix).test(s)
    },
    matchHunterName(s) {
      if ((s || '').trim() == '') return false

      let excluded = this.value.excludedKeyword.trim()
      if (excluded != '' && new RegExp(makePattern(excluded)).exec(s)) return false

      let prefix = makePrefix(this.value.commandPlace)
      let infix = makePattern(this.value.commandToReserve)
      let suffix =
         this.value.hunterNameSeparator == 'space' ? '[ 　]+(.+)' :
         this.value.hunterNameSeparator == 'atmark' ? '[ 　]*[@＠]+(.+)' :
         '[ 　]*([\\[［](.+)[\\]］]|[<＜](.+)[>＞]|「(.+)」|『(.+)』|【(.+)】|〈(.+)〉|《(.+)》)'  // bracket

      let p = prefix + infix + suffix
      return s.match(p)
    },
    getHunterName(s) {
      if ((s || '').trim() == '') return ''

      let m = this.matchHunterName(s)
      if (! m) return ''
      return m[2]
    },
  },
}

function makePrefix(commandPlace) {
  return commandPlace == 'head'
    ? '^[ 　]*'
    : ''
}
function makePattern(command) {
  if ((command || '').trim() == '') return null

  let pattern = command.trim().split(/\s+/)
    .filter(s => s.trim() != '')
    .sort((a, b) => b.length - a.length)  // 長い文字列から確かめていく
    .map(r => _.escapeRegExp(r))
    .join('|')
  return `(${pattern})`
}

function makeEntry(name, hunterName) {
  return {
    name: name || '',
    hunterName: hunterName || '',
    memo: '',
  }
}
</script>
